import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Grid, Typography, List, ListItem, ListItemText, Button } from '@mui/material';

const VisualizarRespostas = () => {
    const [respostas, setRespostas] = useState([]);

    useEffect(() => {
        const fetchRespostas = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/admin/vizualizar-respostas`, {
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('token')}` // Se estiver usando JWT
                    }
                });
                setRespostas(response.data);
            } catch (error) {
                console.error('Erro ao carregar as respostas:', error);
            }
        };

        fetchRespostas();
    }, []);

    return (
        <Grid container direction="column" alignItems="flex-start" style={{ padding: '20px', marginBottom: '2em' }}>
            <Typography variant="h4" gutterBottom>Respostas Enviadas</Typography>
            <List>
                {respostas.map((resposta) => (
                    <ListItem key={resposta.id}>
                        <ListItemText 
                            primary={`Pergunta: ${resposta.pergunta.texto}`} 
                            secondary={`Resposta: ${resposta.resposta}`} 
                        />
                    </ListItem>
                ))}
            </List>
            <Button variant="contained" color="primary" onClick={() => window.location.href = '/'}>
                Voltar
            </Button>
        </Grid>
    );
};

export default VisualizarRespostas;
